(function(){
'use strict';

angular.module('classy').component('cpCartPaymentWidget', {
  template: '\n    <div class="cp-payment-widget">\n      <cp-credit-card-widget\n        data-ng-if="$ctrl.show.cc()"\n        payment="$ctrl.payment.cc"\n        on-token="$ctrl.handleTokenexToken(token)"\n        on-card="$ctrl.handleTokenexCard(brand, lastFour)"\n        primary-color="$ctrl.theme.current.styles.primaryColor"\n        hide-postal="$ctrl.hidePostal"\n        hide-label="true"\n      ></cp-credit-card-widget>\n\n      <cp-stripe-widget\n        ng-class="{\'donation-table_column mobile-large-half\' : $ctrl.isDonationCheckoutPage } "\n        data-ng-if="$ctrl.show.stripe()"\n        model="$ctrl.payment.stripe"\n        card-error-class-name="donation-error"\n        input-class-name="donation-text_input"\n        hide-postal="$ctrl.hidePostal"\n        currency="$ctrl.currency"\n      ></cp-stripe-widget>\n\n      <div ng-hide="$ctrl.payment.ach.status === \'success\' || $ctrl.payment.paypal.status === \'success\' || (!$ctrl.show.paypal() && !$ctrl.show.ach())"\n        class="cp-payment-widget__payment-option-text">\n        Or select another payment option:\n      </div>\n      \n      <div\n        class="cp-payment-widget__alternates"\n        ng-if="$ctrl.show.paypal() || $ctrl.show.ach()"\n        ng-class="{ \'logged-in\': $ctrl.loggedIn()  }">\n\n        <cp-plaid-widget\n          data-ng-if="$ctrl.show.ach()"\n          model="$ctrl.payment.ach"\n          sc-validity-reporter\n          ng-model="$ctrl.payment.ach.status"\n          on-ready="$ctrl.onAchReady()"\n          on-success="$ctrl.onAchSuccess()"\n          on-cancel="$ctrl.onAchCancel()"\n          currency="$ctrl.currency"\n        ></cp-plaid-widget>\n        \n        <cp-cart-paypal-widget\n          data-ng-if="$ctrl.show.paypal()"\n          model="$ctrl.payment.paypal"\n          sc-validity-reporter\n          ng-model="$ctrl.payment.paypal.status"\n          on-ready="$ctrl.onPaypalReady()"\n          on-success="$ctrl.onPaypalSuccess(params)"\n          on-cancel="$ctrl.onPaypalCancel()"\n          currency="$ctrl.currency"\n        ></cp-paypal-widget>\n      </div>\n    </div>\n  ',
  bindings: {
    payment: '<',
    parentModel: '<',
    api: '=',
    hidePostal: '<',
    disabledPaymentMethods: '<',
    currency: '<'
  },
  controller: ["$window", "$q", "$rootScope", "$scope", "$timeout", "$http", "$state", "scThemesService", "cpConstants", "cpAPI", function controller($window, $q, $rootScope, $scope, $timeout, $http, $state, scThemesService, cpConstants, cpAPI) {
    var _this = this;

    /* Utils
    ========================================================= */
    this.getPaymentMethodStatus = function (processors, paymentMethod) {
      return processors[paymentMethod] && !_this.disabledPaymentMethods.includes(paymentMethod) ? STATUS.READY : STATUS.INACTIVE;
    };

    /* Setup
    ========================================================= */
    var STATUS = cpConstants.STATUS,
        EVENTS = cpConstants.EVENTS,
        PAYMENT_METHODS = cpConstants.PAYMENT_METHODS;

    this.eventCallbacks = {};
    this.theme = scThemesService.active.current;
    this.STATUS = STATUS;
    this.PAYMENT_METHODS = PAYMENT_METHODS;
    this.EVENTS = EVENTS;

    this.paymentTypeInitStatus = function (type) {
      return _.get(_this.payment, type + '.status') || STATUS.INACTIVE;
    };

    this.$onInit = function () {
      _this.api = _this.api || {};
      _this.parentModel = _this.parentModel || {};
      _this.disabledPaymentMethods = _this.disabledPaymentMethods || [];
      _this.isDonationCheckoutPage = !!$state.current.name.includes('frs.donation.checkout');

      _this.api.setModelPayment = _this.setModelPayment.bind(_this);
      _this.api.getPaymentLabel = _this.getPaymentLabel.bind(_this);
      _this.api.reloadTokenexIframe = _this.reloadTokenexIframe.bind(_this);
      _this.api.getPaymentMethod = _this.getPaymentMethod.bind(_this);
      _this.api.setModelPaymentMethodGateway = _this.setModelPaymentMethodGateway.bind(_this);

      _this.getProcessors().then(function (processors) {
        _this.processors = processors;
        _this.isPaypalReady = _.get(_this.payment.paypal, 'status', null) !== null;
        _this.initPaymentMethodStatuses(_this.isPaypalReady);
      });
    };

    this.setModelPaymentMethodGateway = function () {
      var isDigitalWallets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var paymentMethod = isDigitalWallets ? PAYMENT_METHODS.STRIPE : _this.getPaymentMethod();
      _this.payment.method = paymentMethod;
      _this.payment.gateway = _this.processors[paymentMethod];
      return paymentMethod;
    };

    /* External Api
    ========================================================= */
    this.setModelPayment = function () {
      var paymentMethod = _this.setModelPaymentMethodGateway();
      var paymentPromise = void 0;

      switch (paymentMethod) {
        case PAYMENT_METHODS.CC:
          {
            paymentPromise = _this.getTokenexToken();
            break;
          }

        case PAYMENT_METHODS.STRIPE:
          {
            paymentPromise = _this.payment.stripe.getSource();
            break;
          }

        case PAYMENT_METHODS.ACH:
        case PAYMENT_METHODS.PAYPAL:
          {
            paymentPromise = $q.resolve();
            break;
          }

        default:
          return $q.reject(new Error('invalid payment method'));
      }

      return paymentPromise;
    };

    this.getPaymentLabel = function () {
      switch (_this.getPaymentMethod()) {
        case PAYMENT_METHODS.STRIPE:
        case PAYMENT_METHODS.CC:
          {
            return 'Card Number';
          }

        case PAYMENT_METHODS.ACH:
          {
            return 'Bank Info';
          }

        case PAYMENT_METHODS.PAYPAL:
          {
            return 'PayPal Account';
          }

        default:
          return 'Payment';
      }
    };

    this.getProcessors = function () {
      if ($window.SC.processors) return $q.resolve($window.SC.processors);

      return $http.get('/frs-api/pay/processors?appId=' + cpAPI.getApplicationId()).then(function (response) {
        return response.data;
      });
    };

    this.reloadTokenexIframe = function () {
      $rootScope.$broadcast('tokenizer', 'reset');
    };

    /* Internal Methods
    ========================================================= */
    this.initPaymentMethodStatuses = function (isPaypalReady) {
      // wrapping in a $timeout to force a separate change detection cycle tick, otherwise UI will not show paypal or plaid widgets when cancelling them
      $timeout(function () {
        /* Adding this condition to prevent Paypal button from appearing twice */
        if (!isPaypalReady || _this.payment.paypal.status === STATUS.PENDING) {
          _this.payment.paypal = {
            status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.PAYPAL)
          };
        }

        _this.payment.ach = {
          status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.ACH)
        };

        // Only override status on reinitializing processors since we could end up deleting
        // api properties set by stripeWidget component (like getSource)
        _this.payment.stripe = Object.assign(_this.payment.stripe || {}, {
          status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.STRIPE)
        });

        _this.payment.cc = {
          status: _this.getPaymentMethodStatus(_this.processors, PAYMENT_METHODS.CC)
        };

        var paymentMethod = _this.getPaymentMethod();
        _this.api.recalculateFees(paymentMethod, _this.processors[paymentMethod].name);
      });
    };

    this.getPaymentMethod = function () {
      if (_this.paymentTypeInitStatus('paypal') === STATUS.SUCCESS) {
        return PAYMENT_METHODS.PAYPAL;
      } else if (_this.paymentTypeInitStatus('ach') === STATUS.SUCCESS) {
        return PAYMENT_METHODS.ACH;
      } else if (_this.show.stripe()) {
        return PAYMENT_METHODS.STRIPE;
      }
      return PAYMENT_METHODS.CC;
    };

    // NOTE: cc and stripe are the only two payment methods that are intrinsically linked (for the time being).
    // This means, one cannot be shown simultaneously with the other. That is why the logic for their show()
    // methods references properties of each other.
    this.show = {
      cc: function cc() {
        var stripeCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.STRIPE, 'currency']);
        var ccCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.CC, 'currency']);
        if (_this.paymentTypeInitStatus('cc') !== STATUS.READY) return false;

        // There is a chance the org still has an old processor active, but under the same currency as
        // Stripe, so we need to hide the tokenex iframe.
        if (_this.currency === stripeCurrencyOverride) return false;

        // If the currency matches for CC but not Stripe, we assume the org wants to show tokenex for this
        // specific currency
        if (_this.currency === ccCurrencyOverride) return true;

        // If the currency is not the default currency for CC BUT the org is not on Stripe,
        // then we show tokenex anyway, as the currency will be converted to the org's
        // default currency
        return _this.paymentTypeInitStatus('stripe') !== STATUS.READY;
      },
      stripe: function stripe() {
        var stripeCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.STRIPE, 'currency']);
        var ccCurrencyOverride = _.get(_this.processors, [PAYMENT_METHODS.CC, 'currency']);

        if (_this.paymentTypeInitStatus('stripe') !== STATUS.READY) return false;

        if (_this.currency === stripeCurrencyOverride) return true;

        // Stripe always supercedes other processors for credit card transactions UNLESS that
        // processor explicitly lists the selected currency as it's default currency
        return _this.currency !== ccCurrencyOverride;
      },
      ach: function ach() {
        return [STATUS.SUCCESS, STATUS.READY].includes(_this.paymentTypeInitStatus('ach'));
      },
      paypal: function paypal() {
        return [STATUS.SUCCESS, STATUS.READY].includes(_this.paymentTypeInitStatus('paypal'));
      },
      or: function or() {
        return [_this.paymentTypeInitStatus('paypal'), _this.paymentTypeInitStatus('ach')].includes(STATUS.READY);
      }
    };

    this.loggedIn = function () {
      return [_this.paymentTypeInitStatus('paypal'), _this.paymentTypeInitStatus('ach')].includes(STATUS.SUCCESS);
    };

    this.getRelevantCurrency = function () {
      return _this.meta.unsupportedTaxCompliance ? _.get(_this.meta, 'estimatedCharge.currency', false) : _this.payment.raw_currency_code;
    };

    this.on = function (event, cb) {
      var cbs = _.get(_this.eventCallbacks, event, []);
      cbs.push(cb);
      _.set(_this.eventCallbacks, event, cbs);
    };

    this.once = function (event, cb) {
      cb.once = true;
      _this.on(event, cb);
    };

    this.emit = function (event) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      console.log(event); // eslint-disable-line no-console
      $timeout(function () {
        var cbs = _.get(_this.eventCallbacks, event, []);
        _.forEach(cbs, function (cb) {
          return cb.apply(undefined, args);
        });
        _.remove(cbs, 'once');
      });
    };

    /* Tokenex
    ========================================================= */
    this.handleTokenexCard = function (brand, lastFour) {
      _this.payment.cc = _this.payment.cc || {};
      _this.payment.cc.card_type = brand;
      _this.payment.cc.card_last_four = lastFour;

      $rootScope.$broadcast('cart:setIsAmex', brand === 'americanExpress');
    };

    this.handleTokenexToken = function (token) {
      this.activeSubmit.resolve(token);
    };

    this.getTokenexToken = function () {
      _this.activeSubmit = $q.defer();
      $rootScope.$broadcast('tokenizer', 'tokenize');
      return _this.activeSubmit.promise.catch(function (err) {
        $rootScope.SC.status.banner = {
          type: 'error',
          msg: 'Please check your payment information and try again.',
          timeout: false
        };
        return $q.reject(err);
      });
    };

    this.reloadTokenexIframe = function () {
      $rootScope.$broadcast('tokenizer', 'reset');
      _this.initPaymentMethodStatuses();
    };

    /* Stripe
    ========================================================= */
    // stripe is handled internally by the cpStripeWidget. The
    // only external method needed is payment.stripe.getSource
    // which is called by this.setModelPayment during form
    // submission

    /* ACH
    ========================================================= */
    this.onAchReady = function () {
      console.log('ACH Ready'); // eslint-disable-line no-console
      _this.payment.paypal.status = STATUS.READY;
    };

    this.onAchSuccess = function () {
      $timeout(function () {
        console.log('ACH Success'); // eslint-disable-line no-console
        $rootScope.$broadcast('checkPaymentAuthStatus', true);
        _this.payment.paypal.status = STATUS.PENDING;
        _this.payment.cc.status = STATUS.PENDING;
        _this.payment.stripe.status = STATUS.PENDING;
      });
    };

    this.onAchCancel = function () {
      console.log('ACH Cancel'); // eslint-disable-line no-console
      $rootScope.$broadcast('checkPaymentAuthStatus', false);
      _this.initPaymentMethodStatuses();
    };

    /* PayPal
    ========================================================= */
    this.onPaypalReady = function () {
      console.log('PayPal Ready'); // eslint-disable-line no-console
      _this.payment.paypal.status = STATUS.READY;
    };

    // Todo: handle hiding billing address autocomplete on paypal success
    this.onPaypalSuccess = function (params) {
      $timeout(function () {
        console.log('PayPal Success'); // eslint-disable-line no-console
        $rootScope.$broadcast('checkPaymentAuthStatus', true);
        _this.payment.ach.status = STATUS.PENDING;
        _this.payment.cc.status = STATUS.PENDING;
        _this.payment.stripe.status = STATUS.PENDING;
        Object.assign(_this.payment.paypal, params.details);

        if (_this.parentModel) {
          _.forEach({
            billing_first_name: 'firstName',
            billing_last_name: 'lastName',
            billing_address1: 'billingAddress.streetAddress',
            billing_address2: 'billingAddress.extendedAddress',
            billing_postal_code: 'billingAddress.postalCode',
            billing_city: 'billingAddress.locality',
            billing_state: 'billingAddress.region',
            billing_country: 'countryCode',
            member_email_address: 'email'
          }, function (ppKey, modelKey) {
            if (!_this.parentModel[modelKey]) {
              _this.parentModel[modelKey] = _.get(params.details, ppKey);
            }
          });
        }
        _this.api.recalculateFees('PayPal', _this.processors.PayPal.name, false);
      });
    };

    this.onPaypalCancel = function () {
      console.log('PayPal Cancel'); // eslint-disable-line no-console
      $rootScope.$broadcast('checkPaymentAuthStatus', false);
      _this.initPaymentMethodStatuses();
    };

    $scope.$on('donationRawCurrencyChange', function () {
      if (_.get(_this.payment.paypal, 'status', null) !== STATUS.READY) {
        _this.isPaypalReady = true;
        _this.initPaymentMethodStatuses(_this.isPaypalReady);
      }
    });
  }]
});
})();